import { LegalLayout, H2, Todo, LEGAL } from "@/components/LegalLayout";

export default function MentionsLegales() {
  return (
    <LegalLayout eyebrow="Informations légales" title="Mentions légales" testId="mentions-legales-page">
      <section>
        <H2>Éditeur du site</H2>
        <p className="mt-2">
          Le site <strong>mini-mellow.com</strong> est édité par <strong>{LEGAL.name}</strong>, {LEGAL.status.toLowerCase()}.<br />
          SIRET : <strong>{LEGAL.siret}</strong><br />
          Siège : <Todo>{LEGAL.address}</Todo><br />
          Contact : <Todo>{LEGAL.email}</Todo> — en attendant, tu peux simplement répondre à l'un de nos e-mails de commande.
        </p>
        <p className="mt-2">Directrice de la publication : la responsable de la micro-entreprise {LEGAL.name}.</p>
        <p className="mt-2">TVA non applicable, article 293 B du Code général des impôts (franchise en base de TVA), sauf mention contraire sur la facture.</p>
      </section>
      <section>
        <H2>Hébergement</H2>
        <p className="mt-2">{LEGAL.host.split("(")[0]}<Todo>({LEGAL.host.split("(")[1]}</Todo></p>
        <p className="mt-2">Les paiements sont traités par <strong>Stripe Payments Europe, Ltd.</strong> (1 Grand Canal Street Lower, Dublin 2, Irlande) — aucune donnée bancaire ne transite par nos serveurs.</p>
      </section>
      <section>
        <H2>Propriété intellectuelle</H2>
        <p className="mt-2">
          L'univers MiniMellow, les MellowFriends (Milo, Lili, Bao, Kiki, Finn, Pipo), MellowCity, les illustrations, textes, logos, visuels et produits présentés sur ce site sont des créations originales protégées par le Code de la propriété intellectuelle. Toute reproduction, représentation, adaptation ou exploitation, totale ou partielle, sans autorisation écrite préalable est interdite.
        </p>
      </section>
      <section>
        <H2>Responsabilité</H2>
        <p className="mt-2">
          Nous apportons le plus grand soin aux informations publiées, mais ne pouvons garantir l'absence d'erreurs ou d'omissions. Les photos et illustrations des produits sont aussi fidèles que possible ; de légères différences de couleur peuvent exister selon ton écran et l'impression.
        </p>
      </section>
      <section>
        <H2>Données personnelles & cookies</H2>
        <p className="mt-2">Consulte notre <a href="/confidentialite" className="text-[#78353A] underline decoration-dotted underline-offset-4">politique de confidentialité & cookies</a> et nos <a href="/cgv" className="text-[#78353A] underline decoration-dotted underline-offset-4">conditions générales de vente</a>.</p>
      </section>
    </LegalLayout>
  );
}
